module.exports = __webpack_public_path__ + "static/media/7.7f93870b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/7.png
// module id = 1287
// module chunks = 0